/**
 * 二手车列表
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 线索发起询价+get
// 接口地址 /api/v1/used_car/ticket/enquiry/<int:ticket_id>
Mock.mock(/used_car\/ticket\/\d+\/enquiry$/, 'put' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'id': 1, // # 成功创建的询价的id
    'finished_at': '12月8日 12：21 '
  }
})

// 拍卖询价列表+get
// 接口地址 /api/v1/auctions/submit_auction_car_enquiry/id
Mock.mock(/auctions\/submit_auction_car_enquiry\/\d+$/, 'put' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'id': 1, // # 成功创建的询价的id
    'finished_at': '12月8日 12：21 '
  }
})
